// extracted by mini-css-extract-plugin
export var divider = "_o2-0";
export var systemMessage = "_o2-1";